import { Inject, Injectable } from '@angular/core';
import Dexie from 'dexie';

import { INDEXED_DB_CONFIG_TOKEN, IndexedDbConfig } from '../../indexed-db/constants/indexed-db.const';

@Injectable({ providedIn: 'root' })
export class IndexedDbDatabase extends Dexie {
  constructor(@Inject(INDEXED_DB_CONFIG_TOKEN) config: IndexedDbConfig) {
    const databaseName: string = config.databaseName;

    super(databaseName);

    config.databaseSchema.forEach((schemaChange) => {
      this.version(schemaChange.databaseVersion)
        .stores(schemaChange.databaseSchemaChange)
        .upgrade(
          schemaChange.databaseUpgrade
            ? (tx) => {
                return tx[schemaChange.databaseUpgrade.table].toCollection().modify(schemaChange.databaseUpgrade.upgradeFn);
              }
            : () => {},
        );
    });
  }
}
